"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));

var _constants = require("./constants");

var toMap = function toMap(arrayOfStrings) {
  return new Map(arrayOfStrings.map(function (key) {
    return [key, true];
  }));
};

var styledSystemProps = toMap(_constants.VALID_STYLED_SYSTEM_PROPS);

var omitProps = function omitProps() {
  var customPropsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$omitStyledSystem = _ref.omitStyledSystemProps,
      omitStyledSystemProps = _ref$omitStyledSystem === void 0 ? true : _ref$omitStyledSystem;

  var shouldForwardProp = function shouldForwardProp(prop) {
    return (0, _isPropValid["default"])(prop) && !customPropsList.includes(prop) && !(omitStyledSystemProps && styledSystemProps.has(prop));
  };

  return {
    shouldForwardProp: shouldForwardProp
  };
};

var _default = omitProps;
exports["default"] = _default;